import styles from './styles.module.css'

export default function TechTableHeader() {
  return (
    <div className={styles.tableHeadersContainer}>
      <div className={styles.tech}>
        <div className={styles.headerText}>Technician</div>
      </div>
      <div className={styles.routes}>
        <div className={styles.headerText}>Routes</div>
      </div>
    </div>
  )
}
